module.exports = __webpack_public_path__ + "img/Sandwich Icon - white.15fc08d8.svg";